import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class SalesGroupId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): SalesGroupId {
    return new SalesGroupId(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
